module.exports = __webpack_public_path__ + "img/Colouring_1200x800.be0e858b.svg";